import { apiFetchWithStatus, type ApiResponseWithStatus } from "@/lib/api";
import { GAIL_API } from "@/utils/common/constants/routes";
import type {
  CreateOrgOutcomeRequest,
  OrgOutcomeDto,
  UpdateOrgOutcomeRequest,
} from "./types";

const ORG_OUTCOMES_URL = `${GAIL_API}/v1/org_outcomes`;

export async function listOrgOutcomes(): Promise<
  ApiResponseWithStatus<OrgOutcomeDto[]>
> {
  return apiFetchWithStatus<OrgOutcomeDto[]>(ORG_OUTCOMES_URL, "GET");
}

export async function createOrgOutcome(
  body: CreateOrgOutcomeRequest
): Promise<ApiResponseWithStatus<OrgOutcomeDto>> {
  return apiFetchWithStatus<OrgOutcomeDto>(ORG_OUTCOMES_URL, "POST", { body });
}

export async function updateOrgOutcome(
  key: string,
  body: UpdateOrgOutcomeRequest
): Promise<ApiResponseWithStatus<OrgOutcomeDto>> {
  return apiFetchWithStatus<OrgOutcomeDto>(
    `${ORG_OUTCOMES_URL}/${encodeURIComponent(key)}`,
    "PUT",
    { body }
  );
}

/** Deletes a custom org outcome by key. */
export async function deleteOrgOutcome(
  key: string
): Promise<ApiResponseWithStatus<null>> {
  return apiFetchWithStatus<null>(
    `${ORG_OUTCOMES_URL}/${encodeURIComponent(key)}`,
    "DELETE"
  );
}
